"use client";
import * as Sentry from "@sentry/nextjs";
import { logger } from "@utilities/logger";
import NextError from "next/error";
import posthog from "posthog-js";
import { useEffect } from "react";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    logger.error(error, "Unhandled application error");
  }, [error]);

  useEffect(() => {
    Sentry.captureException(error);
    posthog.captureException(error, { service: "marketing-website", exception_source: "client" });
  }, [error]);

  return (
    <html lang='en'>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
